import { StepOneRequestDTO } from './dto/StepOneRequestDTO';
import { StepOneResponseDTO } from './dto/StepOneResponseDTO';
import { StepTwoRequestDTO } from './dto/StepTwoRequestDTO';

export class Signer {
  api = null;

  certificate = null;

  /**
   * @param {SignApi} api
   * @param {Object} certificate
   */
  constructor ({ api, certificate }) {
    this.api = api
    this.certificate = certificate
  }

  async sign (position = null) {
    if (!window.cadesplugin) {
      throw new Error('Не получилось загрузить плагин КриптоПро ЭЦП. Подпись недоступна')
    }

    let certificate = this.getCertificate()

    if (!certificate) {
      throw new Error('Не получилось загрузить плагин КриптоПро ЭЦП. Подпись недоступна')
    }

    let algorithm = await this.getHashAlgorithm()

    if (!algorithm) {
      throw new Error('Невозможно подписать документ этим сертификатом')
    }
    let stepOneResponse = {}
    try {
      stepOneResponse = await this.api.stepOne(
        new StepOneRequestDTO({
          algorithm,
          owner: await certificate.SubjectName,
          from: await certificate.ValidFromDate,
          to: await certificate.ValidToDate,
          number: await certificate.SerialNumber,
          position
        })
      )
    } catch (error) {
      this.axiosErrorHandler(error)
    }

    stepOneResponse = stepOneResponse.data

    if (!(stepOneResponse instanceof StepOneResponseDTO)) {
      throw new Error('Формирование печатной формы завершилось неуспешно')
    }

    const next = stepOneResponse.next
    const sign = await this.generateSignature(stepOneResponse.hash)
    let stepTwoRequest = Object.assign({ sign }, stepOneResponse);
    stepTwoRequest = new StepTwoRequestDTO(stepTwoRequest)

    try {
      await this.api.stepTwo(stepTwoRequest)
    } catch (error) {
      this.axiosErrorHandler(error)
    }

    if (next) {
      await this.sign(next)
    }
  }

  async getHashAlgorithm () {
    let certificate = await this.getCertificate()
    const certPublicKey = await certificate.PublicKey()
    const certAlgorithm = await certPublicKey.Algorithm
    const algorithmValue = await certAlgorithm.Value
    const algorithmMap = new Map([
      ['1.2.643.7.1.1.1.1', window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256],
      ['1.2.643.7.1.1.1.2', window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512],
      ['1.2.643.2.2.19', window.cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411]
    ])

    return algorithmMap.get(algorithmValue)
  }

  async generateSignature (hashValue) {
    const oSigner = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner')
    oSigner.propset_Certificate(this.getCertificate())
    oSigner.propset_Options(window.cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN)

    const hashObject = await window.cadesplugin.CreateObjectAsync('CAdESCOM.HashedData')
    hashObject.propset_Algorithm(await this.getHashAlgorithm())
    hashObject.SetHashValue(hashValue)

    // Задание типа подписи
    const cades = window.cadesplugin.CADESCOM_CADES_BES

    const oSignedData = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData')
    oSignedData.propset_ContentEncoding(window.cadesplugin.CADESCOM_BASE64_TO_BINARY)
    const signatureHex = await oSignedData.SignHash(hashObject, oSigner, cades)

    // Проверяем подпись
    let oSignedData2 = await window.cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData')
    try {
      await oSignedData2.VerifyHash(hashObject, signatureHex, cades)
    } catch (err) {
      throw new Error('Ошибка при верификации подписи: ' + err.toString())
    }

    return signatureHex
  }

  axiosErrorHandler (error) {
    if (error.isAxiosError) {
      let message = error.response?.data?.message ?? error.response?.data?.data?.message

      if (message) {
        throw new Error('Ошибка удалённого запроса: \'' + message + '\'')
      }
    }

    throw error
  }

  getCertificate () {
    return this.certificate;
  }
}
